import clsx from "clsx";
import { lazy, Suspense } from "react";

import { Skeleton } from "@/components/Skeleton/Skeleton";

import type { HotelMapProps } from "./HotelMap";

const HotelMap = lazy(() => import("./HotelMap"));

function HotelMapSkeleton({ fullHeight }: { fullHeight?: boolean }) {
  return (
    <div
      className={clsx("overflow-hidden rounded-2xl", { "h-full": fullHeight })}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height={fullHeight ? "100%" : 200}
      />
    </div>
  );
}

function HotelMapLazy(props: HotelMapProps) {
  return (
    <Suspense fallback={<HotelMapSkeleton fullHeight={props.fullHeight} />}>
      <HotelMap {...props} />
    </Suspense>
  );
}

export { HotelMapLazy as HotelMap };
